const ThemeStyles = {
    default: {
        dominant: '#e0201d',
        secondDominant: '#d8e9f0',
        thirdDominant: '#33425b',
        lastDominant: '#29252c'
    },
    thunderstorm: {
        dominant: '#cfc5bc',
        secondDominant: '#6284ad',
        thirdDominant: '#eef2f5',
        lastDominant: '#2b2300'
    },
    drizzle: {
        dominant: '#cfc5bc',
        secondDominant: '#6284ad',
        thirdDominant: '#eef2f5',
        lastDominant: '#2b2300'
    },
    rain: {
        dominant: '#cfc5bc',
        secondDominant: '#6284ad',
        thirdDominant: '#eef2f5',
        lastDominant: '#2b2300'
    },
    snow: {
        dominant: '#ffffff',
        secondDominant: '#6aa6d4',
        thirdDominant: '#d3dce3',
        lastDominant: '#2b2300'
    },
    atmosphere: {
        dominant: '#cfc5bc',
        secondDominant: '#6284ad',
        thirdDominant: '#eef2f5',
        lastDominant: '#2b2300'
    },
    sunny: {
        dominant: '#ffd656',
        secondDominant: '#fffddb',
        thirdDominant: '#e8ab17',
        lastDominant: '#2b2300'
    },
    clouds: {
        dominant: '#cfc5bc',
        secondDominant: '#6284ad',
        thirdDominant: '#eef2f5',
        lastDominant: '#2b2300'
    },
}

export default ThemeStyles;